import { brandValues, siteMeta, testimonials } from '@/mocks/home';

export default function BrandSection() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-8xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.2em] text-accent-700">
              <i className="ri-building-2-line"></i>
              ABOUT US
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              我们为什么做{siteMeta.name}
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              娱乐热点每天都在发生，但大多数人只看到结论，看不到过程。{siteMeta.name}
              想做的事情很朴素：把事件拆回它原本的样子，把机制讲清楚，把依据摆出来。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们不生产情绪，也不替任何人下判断。你在这里看到的每一条链路、每一个节点，都可以被查证、被讨论，也可以被纠正。
            </p>

            <div className="mt-7 rounded-lg border border-background-300/70 bg-background-100 p-5">
              <p className="font-heading text-base font-semibold text-foreground-900">
                {siteMeta.slogan}
              </p>
              <p className="mt-2 text-xs text-foreground-500">
                内容原则：先核验，再表达；只讨论机制，不针对个人。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {brandValues.map((value) => (
                <div
                  key={value.id}
                  className="rounded-lg border border-background-300/70 bg-background-50 p-5"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700">
                    <i className={value.icon}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                    {value.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{value.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 md:mt-16">
          <div className="flex items-center gap-3">
            <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
              读者怎么说
            </h3>
            <span className="hairline flex-1"></span>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((item) => (
              <figure
                key={item.id}
                className="flex h-full flex-col rounded-lg border border-background-300/70 bg-background-100 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.quote}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="h-10 w-10 shrink-0 overflow-hidden rounded-full">
                    <img
                      src={item.avatar}
                      alt={`${item.name}头像`}
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <span className="min-w-0">
                    <span className="block truncate text-sm font-medium text-foreground-900">
                      {item.name}
                    </span>
                    <span className="block truncate text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}